<template>
  <div class="overview">
    <div class="container">
      <h1>{{ $t('整體表現') }}</h1>
      <div class="group">
        <h2>
          {{ $t('答題時間關係圖') }}
          <br>
          （{{ $t('共') }} {{ chartData.length }} {{ $t('人完成作答') }}）
        </h2>
        <ScatterChart
          :chart-data="chartData"
          :highlight="highlight"
          :quiz-total-score="quizTotalScore"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ScatterChart from './ScatterChart';

export default {
  components: {
    ScatterChart,
  },
  props: {
    chartData: {
      type: Array,
      required: true,
    },
    highlight: { // {label: string, x: number, y: number}
      type: Object,
      default: null,
    },
    quizTotalScore: {
      type: Number,
      default: 0,
    },
  },
  computed: {
  },
};
</script>

<style scoped lang="scss">
.overview {
  .container{
    max-width: 1200px;
    padding: 0 20px;
    margin: auto;
    h1{
      display: flex;
      justify-content: flex-start;
      border-bottom: 2px solid black;
      padding-bottom: 10px;
      margin-top: 20px;
      margin-bottom: 30px;
      font-size: 1.8rem;
    }

    .group {
      margin-top: 30px;
      h2 {
        margin-bottom: 10px;
        font-size: 1.2rem;
        text-align: center;
      }
      .chart {
        max-width: 600px;
        margin: auto;
        img {
          width: 100%;
        }
        .txt{
          margin-top: 20px;
          p{
            text-align: left;
          }
        }
      }
    }
  }
}
</style>
